import { api } from './configs';
import { SERVER_URL } from '../constants';

class Api {
  static url = SERVER_URL;

  /* Account Start */

  static auth(body) {
    return api.post('/auth', body);
  }

  /* Account End */

  /* Nicknames Start */

  static getNicknames(params) {
    return api.get('/nicknames', { params });
  }

  static getMyNicknames(params) {
    return api.get('/nicknames-my', { params });
  }

  static createNickname(body) {
    return api.post('/nicknames', body);
  }

  static changeNicknameStatus(body) {
    return api.put('/nicknames', body);
  }

  /* Nicknames End */

  /* Static Start */

  static getStatuses(params) {
    return api.get('/statuses', { params });
  }

  static getStaticNicknames(params, signal) {
    return api.get('/static/nicknames', { signal, params });
  }

  /* Static End */

  /* Ton Start */

  static generateTransaction(body) {
    return api.post('/payments/generate', body);
  }

  /* Ton End */
}

export default Api;
